// extracted by mini-css-extract-plugin
export var btnNext = "style-module--btn-next--6f6fa";
export var btnPrev = "style-module--btn-prev--e9668";
export var revs = "style-module--revs--d14d9";